import { Table, TableBody, TableCell, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { StyledTableHead } from '../../styles';
import type { CoparticipationMainRowProps } from './types';
import { CoparticipationSubRow } from '../CoparticipationSubRow';
import { TableRowNew } from './styles';

export function CoparticipationSubTable({
  details,
  columnsSubRow,
}: CoparticipationMainRowProps) {
  return (
    <Table size="small" aria-label="detalhes" sx={{ minWidth: '930px' }}>
      <StyledTableHead>
        <TableRowNew>
          {columnsSubRow.map(column => (
            <TableCell
              key={column.id}
              align={column.align}
              width={column.width}
            >
              <Typography
                variant="text"
                color={NEW_COLORS.SECONDARY[600]}
                fontWeight={600}
                minWidth="52px"
              >
                {column.label}
              </Typography>
            </TableCell>
          ))}
          <TableCell
            sx={{
              borderBottom: 'unset',
              borderTop: `1px solid ${NEW_COLORS.GRAYSCALE[100]}`,
            }}
          />
        </TableRowNew>
      </StyledTableHead>
      <TableBody>
        {details.map((detail, index) => (
          <CoparticipationSubRow
            key={detail.id}
            detail={detail}
            index={index}
            detailsLength={details.length}
            columnsSubRow={columnsSubRow}
          />
        ))}
      </TableBody>
    </Table>
  );
}
